import LoginProvider from './hooks/useLogin';

import { LoginProps } from './@types/LoginProps';
import LoginButton from './handles/LoginButton';
import LoginLabel from './handles/LoginLabel';
import PortalContainer from './handles/PortalContainer';
import LoginBox from './handles/LoginBox';
import LoginArrowUp from './handles/LoginArrowUp';
import LoginContentContainer from './handles/LoginContentContainer';
import LoginOptions from './handles/LoginOptions';
import LoginFormTitle from './handles/LoginFormTitle';
import LoginOptionsList from './handles/LoginOptionsList';
import LoginOptionsListItem from './handles/LoginOptionsListItem';
import LoginContentButton from '../Login/handles/LoginContentButton';
import EmailAndPassOption from '../Login/handles/EmailAndPassOption';
import OptionsListItemContainer from '../Login/handles/OptionsListContainer';
import ContentForm from './handles/ContentForm';
import EmailVerification from './handles/EmailVerification';
import LoginInput from './handles/LoginInput';
import FormLink from './handles/FormLink';
import ForgotPassword from './handles/ForgotPassword';
import DontHaveAccount from './handles/DontHaveAccount';
import FormFooter from './handles/FormFooter';
import SendButton from './handles/SendButton';
import BackButton from './handles/BackButton';
import { useEffect, useRef, useState } from 'react';

import './Login.scss';
import { createPortal } from 'react-dom';

const Login = (props: LoginProps) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [login, setLogin] = useState<boolean>(false);
	const [domReady, setDomReady] = useState<boolean>(false);

	useEffect(() => {
		setDomReady(true);
	}, []);

	//useref
	const loginRef = useRef<HTMLDivElement>(null);

	const handleClick = () => {
		setIsOpen(!isOpen);
		if (login) {
			setLogin(!login);
		}
	};

	const handleLogin = () => {
		setLogin(!login);
	};

	return (
		<LoginProvider {...props}>
			<div className="vtex-login-2-x-container container flex items-center fr">
				<div className="relative" ref={loginRef}>
					<LoginButton handleClick={handleClick}>
						<LoginLabel></LoginLabel>
					</LoginButton>
					{domReady &&
						createPortal(
							<PortalContainer loginRef={loginRef} isOpen={isOpen}>
								<LoginBox>
									<LoginArrowUp />
									<LoginContentContainer>
										{login ? (
											<ContentForm>
												<EmailVerification>
													<LoginInput></LoginInput>
													<FormLink>
														<ForgotPassword></ForgotPassword>
													</FormLink>
													<FormFooter>
														<BackButton handleClick={handleLogin}></BackButton>
														<SendButton></SendButton>
													</FormFooter>
													<FormLink>
														<DontHaveAccount></DontHaveAccount>
													</FormLink>
												</EmailVerification>
											</ContentForm>
										) : (
											<LoginOptions>
												<LoginFormTitle></LoginFormTitle>
												<LoginOptionsList>
													<LoginOptionsListItem>
														<LoginContentButton />
													</LoginOptionsListItem>
													<LoginOptionsListItem>
														<EmailAndPassOption handleClick={handleLogin} />
													</LoginOptionsListItem>
													<OptionsListItemContainer />
												</LoginOptionsList>
											</LoginOptions>
										)}
									</LoginContentContainer>
								</LoginBox>
							</PortalContainer>,
							document.getElementsByClassName('canvas-iframe')[0] as HTMLElement,
						)}
				</div>
			</div>
		</LoginProvider>
	);
};

export default Login;
